
// import the interface

import { CrudTableAction, TablesActionType } from '../actions/tables.action';
import { Tables } from '../models/tables.model';
//create a dummy initial state
const initialState: Tables[] = [];
export function tableReducer(state: Tables[] = initialState,action: CrudTableAction) {
  switch (action.type) {
    case TablesActionType.GET_TABLES:
      state=action.payload;
      return {
        ...state
      };
    default:
      return state;
  }
}

